module.exports = "/assets/regin-dipswitch.png";